const ID = 'navigation';

export default ID;
